import { MAG } from "../services";

const prefix = "/api/mas/auth";

export const postLogin = async (body) => {
  const endpoint = `${prefix}/login`;
  // const endpoint = "/api/system/admin/login";
  return await MAG.post(endpoint, { ...body });
};
